document.addEventListener('DOMContentLoaded', function() {
  function initFasterDeliveryButton() {
    const textContainer = document.querySelector('.text-container');
    const closeButton = document.querySelector('.close-button');
    const imageWidth = document.querySelector('.image_class')?.offsetWidth || 45;
    
    if (!textContainer || !closeButton) return;
    
    // Show text after 5 seconds
    setTimeout(() => {
      textContainer.classList.add('visible');
      textContainer.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
    }, 5000);
    
    closeButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      
      // Add transition for smooth movement
      textContainer.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
      
      // Move text to align with image width
      textContainer.style.transform = `translateX(${imageWidth}px)`;
      textContainer.classList.add('hidden');
      textContainer.classList.remove('visible');
      
    });
  }
  
  initFasterDeliveryButton();
});